"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BorderStyleIcon = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const SQUIGGLY_PERIOD = 6;
const SQUIGGLY_AMP = 1.5;
const svgStyle = { display: 'block', overflow: 'visible' };
const wrapStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    verticalAlign: 'middle',
};
/**
 * Build a closed wavy line from `start` to `end` along the segment axis,
 * with the perpendicular axis fixed at `mid`. Used by both orientations.
 */
const squigglyPath = (start, end, mid, axis) => {
    const len = end - start;
    if (len <= 0)
        return '';
    // Even number of half-waves so the line ends on the baseline.
    const halfWaves = Math.max(2, Math.round(len / (SQUIGGLY_PERIOD / 2)) & ~1);
    const seg = len / halfWaves;
    let d = axis === 'horizontal' ? `M ${start} ${mid}` : `M ${mid} ${start}`;
    let side = 1;
    for (let i = 0; i < halfWaves; i++) {
        const tCtrl = start + seg * (i + 0.5);
        const tEnd = start + seg * (i + 1);
        const offset = SQUIGGLY_AMP * side;
        if (axis === 'horizontal') {
            d += ` Q ${tCtrl.toFixed(2)} ${(mid - offset).toFixed(2)} ${tEnd.toFixed(2)} ${mid}`;
        }
        else {
            d += ` Q ${(mid - offset).toFixed(2)} ${tCtrl.toFixed(2)} ${mid} ${tEnd.toFixed(2)}`;
        }
        side = -side;
    }
    return d;
};
/**
 * Small icon that previews a stroke style as a horizontal (or vertical) line
 * through the middle of a square hit-box. All styles render via inline SVG
 * so the stroke is precisely centered regardless of orientation.
 */
const BorderStyleIcon = ({ style, size = 16, strokeWidth = 2, padding = 2, orientation = 'horizontal', }) => {
    if (style === 'none') {
        // Render an empty hit-box so the icon column still aligns, but draw
        // nothing — the option is "no line".
        return React.createElement("span", { style: { ...wrapStyle, width: size, height: size }, "aria-hidden": "true" });
    }
    const vertical = orientation === 'vertical';
    const start = padding;
    const end = size - padding;
    const mid = size / 2;
    let body;
    if (style === 'squiggly') {
        body = (React.createElement("path", { d: squigglyPath(start, end, mid, orientation), fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round" }));
    }
    else {
        let dashArray;
        let linecap = 'butt';
        if (style === 'dashed') {
            dashArray = `${strokeWidth * 1.6} ${strokeWidth * 1.2}`;
        }
        else if (style === 'dotted') {
            dashArray = `0 ${strokeWidth * 1.5}`;
            linecap = 'round';
        }
        else {
            linecap = 'round';
        }
        body = (React.createElement("line", { x1: vertical ? mid : start, y1: vertical ? start : mid, x2: vertical ? mid : end, y2: vertical ? end : mid, stroke: "currentColor", strokeWidth: strokeWidth, strokeDasharray: dashArray, strokeLinecap: linecap }));
    }
    return (React.createElement("span", { style: wrapStyle, "aria-hidden": "true" },
        React.createElement("svg", { width: size, height: size, viewBox: `0 0 ${size} ${size}`, style: svgStyle }, body)));
};
exports.BorderStyleIcon = BorderStyleIcon;
